import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';


@Injectable({
    providedIn: 'root',
})
export class ApiUrlService {
    private apiUrl = '';
    private frontendHost = '';
    private readonly nonProdHost = 'web.dev.ocp.webapp.idst.ibaintern.de';
    private readonly path = '/pd/v1';
    private readonly uploadPath = '/ud/v1';


    constructor() {
        this.init();
    }


    getApiUrl(): string {
        return `${this.apiUrl}${this.path}`;
    }


    getUploadApiUrl(): string {
        return `${this.apiUrl}${this.uploadPath}`;
    }


    private init(): void {
        const location = globalThis.location;

        this.frontendHost = location.origin;
        this.apiUrl = this.calculateApiUrl(location);
    }


    private calculateApiUrl(location: Location): string {
        if (environment.local) {
            return environment.apiUrl;
        }

        if (environment.backendOverrideUrl && this.frontendHost.includes(this.nonProdHost)) {
            return environment.backendOverrideUrl;
        }

        const basePath = location.pathname
            .replace('/kokos-ui-', '/kokos-')
            .split('/')
            .slice(0, 2)
            .join('/');


        return `${location.origin.replace('://web', '://rest')}${basePath}/kokos-ui-service`;
    }

}